<template>
    <v-row>
        <v-dialog
                v-model="dialog"
                width="800px"
        >
            <v-card>
                <v-card-title>
                    <span class="text-h5">{{ datconfig.billing_provider_name }} - {{ datconfig.billing_provider_id }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container class="grey lighten-5">
                        <v-row no-gutters>
                            <v-col cols="12" sm="4">
                                <div class="text--primary">Empresa propietaria </div>
                                <div>{{ datconfig.owner_company_name}}</div>
                            </v-col>

                            <v-col cols="12"sm="4">
                                <div class="text--primary">Divisa </div>
                                <div>{{ datconfig.currency}}</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="text--primary">Emisor </div>
                                <div>{{ datconfig.vendor}}</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="text--primary">Tipo de tarjeta </div>
                               <div>{{ datconfig.type}}</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                               <div class="text--primary">Tipo de cancelacion </div>
                               <div>{{ datconfig.cancellation_type}}</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="text--primary">Intervalo de validez </div>
                                <div>{{ datconfig.validity_end_interval}}</div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="4">
                               <div class="text--primary">Tipo de periodo inicio validez </div>
                               <div>{{ datconfig.validity_period_start_type}}</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="text--primary">Tipo de periodo fin validez </div>
                                <div>{{ datconfig.validity_period_end_type}}</div>
                            </v-col>

                            <v-col cols="12" sm="4">
                                <div class="text--primary">Fecha de carga</div>
                                <div>{{ datconfig.charge_date_type}}</div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="4">
                                <div class="text--primary">Email de notificacion </div>
                                <div>{{ datconfig.primary_email_notification}}</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="text--primary">Plataforma </div>
                                <div>{{ datconfig.security_context_name}}</div>
                            </v-col>
                        </v-row>
                      </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="close"
                    >
                        Salir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import axios from "axios";
    import getBaseUrl from "../utils/baseUrl";

    export default {
        data () {
            return {
                dialog: false,
                datconfig: [],
                loading: false
            }
        },
        methods:{
            activate(item){
                this.dialog = true;
                this.datconfig = item;
            },
            close(){
                this.dialog = false;
                this.datconfig = [];
                this.$emit('closeDetails');
            },
        }
    }
</script>